import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { event, promise } from '../data/masterclass';
import { EnrollFlow } from './EnrollFlow';
import { Countdown } from './Countdown';
const EASE = [0.23, 1, 0.32, 1] as const;
type HeroProps = {
  paid: boolean;
  onPay: () => void;
};
export function Hero({
  paid,
  onPay
}: HeroProps) {
  return <header className="relative isolate overflow-hidden bg-ink" data-id="element-61" data-mp="1297cu5rar3ad">
      <img src={event.backdropUrl} alt="" aria-hidden="true" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-70" data-id="element-62" data-mp="127efjh2kpvf1" />
      <div className="absolute inset-0 -z-10 bg-ink/60" aria-hidden="true" data-id="element-63" data-mp="s9zxxe4wz0l5" />

      <div className="mx-auto w-full max-w-7xl px-6 pb-16 pt-8 lg:px-10 lg:pb-20" data-id="element-64" data-mp="nczr3108ptsz">
        <img src={event.logoUrl} alt="Meet the Eatmons" className="h-20 w-20 object-contain sm:h-24 sm:w-24" data-id="element-65" data-mp="3d1a4za4glt8j" />

        <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-66" data-mp="3814bdoempwnt">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: EASE
        }} data-id="element-67" data-mp="3j9tzsvxzjik8">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-gold" data-id="element-68" data-mp="39b4ib4a0404i">
              {event.dateLabel} at {event.timeLabel}
            </p>
            <h1 className="mt-3 font-display text-6xl font-bold uppercase leading-[0.92] text-white sm:text-7xl lg:text-8xl" data-id="element-69" data-mp="3ebir4ojffe3l">
              Unified <span className="text-gold" data-id="element-70" data-mp="3599iy5bmrwtd">Success</span>
              <span className="block" data-id="element-71" data-mp="35a2jupnwrs3l">Masterclass</span>
            </h1>
            <p className="mt-5 font-display text-2xl font-medium uppercase tracking-wide text-white/70 sm:text-3xl" data-id="element-72" data-mp="2ql6a8o67e70v">
              with Curtis &amp; Spring Eatmon IV
            </p>
          </motion.div>

          <motion.img src={event.portraitUrl} alt="Curtis and Spring Eatmon IV" initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.55,
          ease: EASE,
          delay: 0.08
        }} className="mt-12 w-full max-w-sm object-cover" data-id="element-73" data-mp="2hkglg4fd1gwn" />

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: EASE,
          delay: 0.12
        }} className="flex w-full flex-col items-center" data-id="element-74" data-mp="ic85x8ls7uuo">
            <p className="mt-12 max-w-2xl text-lg leading-relaxed text-white/70" data-id="element-75" data-mp="1azktnm3oi8pk">
              {promise}
            </p>

            <div className="mt-8 flex w-full justify-center" data-id="element-76" data-mp="162lzj3k0m1rd">
              <EnrollFlow paid={paid} onPay={onPay} data-id="element-77" data-mp="111y8wizp7mxo" />
            </div>

            <div className="mt-10 flex w-full flex-col items-center gap-6 border-t border-gold/20 pt-8" data-id="element-78" data-mp="x1ef9pec31ga">
              <Countdown data-id="element-79" data-mp="3lsoyezdi9t7k" />
              <p className="flex items-center gap-2 text-sm text-white/55" data-id="element-80" data-mp="3lu02l0av52z7">
                <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-81" data-mp="3hqu083qvfvy0" />
                Live on Zoom · Replay included
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </header>;
}